<template>
  <div
    id="app"
    v-loading="!dialogVisible"
    :element-loading-text="$t('loading')"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class=""></div>
    <router-view v-if="dialogVisible" />
  </div>
</template>

<style lang="less">
.operator-wrapper {
  justify-content: space-between;
  height: 100%;
  .operator-menu-box {
  }
  .operator-content {
    width: 100%;
    height: 95%;
    overflow-y: auto;
    overflow-x: hidden;
  }
}
</style>
<script type="text/ecmascript-6">
  import store from '@/store'
  const { userGuidanceList } = require(`@/version/${store.getters.versionConfig}.js`)

  export default {
  data () {
    return {
      userGuidanceList: userGuidanceList, // userGuidanceList,
      dialogVisible: false
    }
  },
  watch: {
    'userGuidance.header': function (v) {
      if (v) {
        this.userGuidanceFn()
      }
    },

    mapSettingInfo: {
      handler: function () {
        this.$store.commit('setMapSettingInfo', this.mapSettingInfo)
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    userGuidance() {
      return this.mainStore.state.user.userGuidance
    },
    mapSettingInfo() {
      return this.mainStore.getters.mapSettingInfo
    },
  },
  destroyed() {
    this.dialogVisible = false
  },
  methods: {
    show() {
      if (this.dialogVisible) {
        return
      }
      let userInfo = window.sessionStorage.getItem('userInfo')
      if (userInfo) {
        userInfo = JSON.parse(userInfo)
        this.$store.commit('setUserInfo', userInfo)
        this.$sdk.initSocket(this.mainStore)
        this.$business.initSocket(this.mainStore)
        this.dialogVisible = true
        this.setPermission()
      }
    },

    setPermission() {
      const permissionIds =
        window.sessionStorage.getItem('permissionIdList') || ''
        // 没有首页权限跳无权限页面
        if(permissionIds.indexOf('dataCenter') === -1)
          this.$router.push({ path: '/noPermissions' })
    },
    /* 用户引导 */
    userGuidanceFn() {
      if (this.userGuidanceList && this.userGuidance) {
        if (
          this.userGuidanceList.length &&
          !this.userGuidance.dataCenter &&
          this.userGuidance.header
        ) {
          this.$deleteConfirmationBox(
            {
              deleteTitleImg: 'tips',
              deleteTitle: this.$t('functionIntroduction'),
              submitClass: 'button_function',
              deleteContent: `<div class="c_9DA7B2" style="letter-spacing: 2px">
              ${this.$t('doYouNeedABeginnerGuide')}
              <span class="c_fff">
              ${this.$t('homePageInstructions')}
              </span>？</div>`,
              closeText: this.$t('skip'),
              submitText: this.$t('confirm')
            },
            () => {
              const userGuidance = this.mainStore.getters.windowFn.userGuidance
              const defineStepsList = []
              const permissionIdList =
                JSON.parse(window.sessionStorage.getItem('permissionIdList')) ||
                []
              /* 判断是否有权限 */
              const userGuidanceList = this.userGuidanceList.filter((v) => {
                if (v.permission) {
                  return (
                    permissionIdList.findIndex(
                      (permission) => permission === v.permission
                    ) !== -1
                  )
                } else {
                  return true
                }
              })
              const num = userGuidanceList.length
              /* 整理引导数据 */
              userGuidanceList.forEach((row, index) => {
                const item = {
                  element: row.element,
                  popover: { ...row.popover }
                }
                let li = ''
                for (let i = 0; i < num; i++) {
                  li += i === index ? '<li class="select"></li>' : '<li></li>'
                }
                if (index === 0) {
                  item.popover.className = 'first-step-class'
                  item.onPrevious = () => {
                    userGuidance.preventMove()
                  }
                }
                item.popover.description = `<div class="content">${item.popover.description}</div><ul class="centerBox">${li}</ul>`
                item.onHighlightStarted = () => {
                  if (row.query && row.path) {
                    this.$router.push({ path: row.path, query: row.query })
                  } else {
                    if (row.path) {
                      this.$router.push({ path: row.path })
                    }
                  }
                }
                item.onNext = () => {}
                defineStepsList.push(item)
              })
              /* 标记当前引导的板块 */
              this.mainStore.commit('guidanceSectionName', 'dataCenter')
              this.$nextTick(() => {
                // this.defineStepsList = defineStepsList
                userGuidance.defineSteps(defineStepsList)
                userGuidance.start()
              })
            },
            () => {
              this.mainStore.dispatch('userGuidanceFn', {
                name: 'dataCenter',
                content: 1
              })
            }
          )
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      const mqObj = this.mainStore.getters.mqObj
      if (mqObj && mqObj.sdkType && mqObj.businessType) {
        this.show()
      }
      this.mainStore.commit('sdkAssignmentCallbackObject', {
        name: 'mqConnectionType',
        callback: (type) => {
          if (type) {
            this.show()
          }
        }
      })
    })
  }
}
</script>

<style lang="less">
.operator-wrapper {
  justify-content: space-between;
  height: 100%;
  .operator-menu-box {
  }
  .operator-content {
    width: 100%;
    height: 95%;
    overflow-y: auto;
    overflow-x: hidden;
  }
}
</style>
